import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Loading } from "@/layouts/components";
import { RoutesList } from "@/router/routesList";
import { useGetCitiesQuery, useGetPlaceByIdQuery, useGetSportsQuery, useUpdatePlaceMutation, useUploadCoverMutation, } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { convertToUpdateDto } from "../common/mappers/convertFromViewModel";
import { convertToViewModel } from "../common/mappers/convertToViewModel";
import { PlaceEditForm } from "./components/PlaceEditForm";
export var PlaceUpdatePage = function () {
    var placeId = useParams().placeId;
    var placeGetState = useGetPlaceByIdQuery({ id: placeId });
    var _a = useUploadCoverMutation(), uploadCoverAction = _a[0], uploadCoverState = _a[1];
    // виды спорта
    var sportsListGetState = useGetSportsQuery({});
    // города
    var citiesListGetState = useGetCitiesQuery({});
    var _b = useUpdatePlaceMutation(), placeUpdateAction = _b[0], placeUpdateState = _b[1];
    var saveFormHandler = function (data) {
        try {
            placeUpdateAction({
                id: placeId,
                updatePlaceDto: convertToUpdateDto(data),
            });
            // файлы для загрузки
            var uploadFiles = Array.from(data.coverFiles).filter(function (el) { return el.status === "added"; });
            if (uploadFiles.length) {
                uploadCoverAction({
                    body: {
                        cover: uploadFiles.map(function (el) { return el.file; }),
                        fileIds: uploadFiles.map(function (el) { return el.id; }),
                    },
                });
            }
        }
        catch (err) {
            console.error(err);
        }
    };
    var navigate = useNavigate();
    useEffect(function () {
        if (placeUpdateState.isSuccess) {
            navigate(RoutesList.Place.getPlacesList());
        }
    }, [placeUpdateState.isSuccess]);
    useSetPageData({ title: "Площадка" });
    return (_jsxs("div", { children: [_jsx(Loading, { isActive: uploadCoverState.isLoading ||
                    placeGetState.isFetching ||
                    placeUpdateState.isLoading ||
                    sportsListGetState.isLoading, loadingKey: "placeUpdate" }), placeGetState.isSuccess &&
                sportsListGetState.isSuccess &&
                citiesListGetState.isSuccess && (_jsx(PlaceEditForm, { data: convertToViewModel(placeGetState.data), sportsDict: sportsListGetState.data.items, citiesDict: citiesListGetState.data.items, mode: "update", onSave: saveFormHandler }))] }));
};
